

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// const Healthbanner = () => {
//   const navigate = useNavigate();
//   const [animate, setAnimate] = useState(false);

//   useEffect(() => {
//     setAnimate(true);
//   }, []);

//   const styles = {
//     container: {
//       position: "relative",
//       width: "100%",
//       height: "90vh",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "flex-start",
//       color: "white",
//       overflow: "hidden",
//       backgroundImage: "url('/image/407475.jpg')",
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//       padding: "50px",
//     },
//     overlay: {
//       position: "absolute",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       backgroundColor: "rgba(0,0,0,0.6)",
//       zIndex: 1,
//     },
//     content: {
//       position: "relative",
//       zIndex: 2,
//       maxWidth: "700px",
//       textAlign: "left",
//       transform: animate ? "translateX(0)" : "translateX(-100px)",
//       opacity: animate ? 1 : 0,
//       transition: "all 1s ease-in-out",
//       padding: "20px", // Added padding for better spacing on mobile
//     },
//     heading: {
//       fontSize: "40px",
//       fontWeight: "bold",
//       marginBottom: "20px",
//       letterSpacing: "0px",
//       color: "white",
//     },
//     text: {
//       fontSize: "18px",
//       lineHeight: "1.6",
//       marginBottom: "30px",
//       textAlign: "justify",
//     },
//     button: {
//       padding: "12px 25px",
//       borderRadius: "25px",
//       border: "none",
//       fontSize: "16px",
//       fontWeight: "bold",
//       cursor: "pointer",
//       backgroundColor: "#0078b7",
//       color: "white",
//       transition: "0.3s ease",
//     },
//     // Media Queries for Responsiveness
//     "@media (max-width: 1024px)": {
//       container: {
//         height: "80vh", // Reduce height for medium screens
//       },
//       content: {
//         maxWidth: "90%", // More space on medium screens
//         padding: "20px",
//       },
//       heading: {
//         fontSize: "36px",
//       },
//       text: {
//         fontSize: "16px",
//       },
//     },
//     "@media (max-width: 768px)": {
//       container: {
//         height: "70vh", // Adjust height for tablets and small screens
//         padding: "30px",
//       },
//       content: {
//         maxWidth: "100%",
//       },
//       heading: {
//         fontSize: "30px", // Smaller heading for mobile
//       },
//       text: {
//         fontSize: "14px", // Smaller text for better readability on smaller screens
//       },
//       button: {
//         padding: "10px 20px",
//         fontSize: "14px", // Smaller button size for mobile
//       },
//     },
//     "@media (max-width: 480px)": {
//       container: {
//         height: "65vh",  
//         padding: "20px",
//       },
//       content: {
//         maxWidth: "100%",
//       },
//       heading: {
//         fontSize: "18px",  
//       },
//       text: {
//         fontSize: "12px", 
//       },
//       button: {
//         padding: "8px 15px",
//         fontSize: "12px",  
//       },
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.overlay}></div>

//       <div style={styles.content}>
//         <h1 style={styles.heading}>
//           Technology, Media & Telecommunications
//         </h1>
//         <p style={styles.text}>
//           When it comes to disruptive, groundbreaking innovation, the leaders in
//           technology, media and telecommunications have a corner on cool. The
//           industry’s impossibly crazy ideas inspire people, transform commerce
//           and convert naysayers. Ready to thrive in a digital world? Deloitte
//           will help you to set the pace, uncover opportunities and spark growth.
//           Together, we’re built for this.
//         </p>
//         <button
//           style={styles.button}
//           onClick={() => navigate("/contactus")}
//         >
//           Contact us
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Healthbanner;










import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const FinancialServices = () => {
  const navigate = useNavigate();
  const [animate, setAnimate] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    // Trigger animation when component mounts
    setAnimate(true);
    
    // Handle resize events for responsiveness
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: isMobile ? "20px" : "50px",
      backgroundColor: "#000",
      //  backgroundImage: "url('/image/407475.jpg')",
      color: "white",
      minHeight: "90vh",
      boxSizing: "border-box",
    },
    left: {
      flex: isMobile ? "0 1 auto" : "1 1 400px",
      padding: isMobile ? "10px" : "20px",
      textAlign: isMobile ? "center" : "left",
      marginBottom: isMobile ? "20px" : "0",
    },
    heading: {
      fontSize: isMobile ? "28px" : "36px",
      fontWeight: "bold",
      marginBottom: "20px",
      letterSpacing: "0px",
      color: "white",
      lineHeight: "1.2",
    },
    text: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: "1.6",
      marginBottom: "30px",
      textAlign: isMobile ? "left" : "justify",
    },
    buttonContainer: {
      display: "flex",
      gap: "15px",
      flexWrap: "wrap",
      justifyContent: isMobile ? "center" : "flex-start",
    },
    button: {
      padding: "12px 25px",
      borderRadius: "25px",
      border: "none",
      fontSize: isMobile ? "14px" : "16px",
      fontWeight: "bold",
      cursor: "pointer",
      transition: "0.3s ease",
      minWidth: isMobile ? "140px" : "auto",
    },
    contactBtn: {
      backgroundColor: "#0078b7",
      color: "white",
    },
    right: {
      flex: isMobile ? "0 1 auto" : "1 1 400px",
      textAlign: "center",
      overflow: "hidden",
      width: isMobile ? "100%" : "auto",
    },
    image: {
      maxWidth: "100%",
      height: "auto",
      maxHeight: isMobile ? "300px" : "none",
      transform: animate ? "translateY(0)" : "translateY(-100px)",
      opacity: animate ? 1 : 0,
      transition: "all 1s ease-in-out",
      borderRadius:"10px",
    },
  };

  return (
    <div style={styles.container}>
      {/* Left Section */}
      <div style={styles.left}>
        <h1 style={styles.heading}>
          Technology, Media & Telecommunications
        </h1>
        <p style={styles.text}>
          When it comes to disruptive, groundbreaking innovation, the leaders in
          technology, media and telecommunications have a corner on cool. The
          industry’s impossibly crazy ideas inspire people, transform commerce
          and convert naysayers. Ready to thrive in a digital world? Deloitte
          will help you to set the pace, uncover opportunities and spark growth.
          Together, we’re built for this.
        </p>
        
        <div style={styles.buttonContainer}>
          <button
            style={{ ...styles.button, ...styles.contactBtn }}
            onClick={() => navigate("/contactus")} // Redirect
          >
            Contact us
          </button>
        </div>
      </div>

      {/* Right Section */}
      <div style={styles.right}>
        <img
          src="/image/23003bf2-21f4-4272-9ac0-651bcde4c650-1.jpg"
          alt="Financial Services"
          style={styles.image}
        />
      </div>
    </div>
  );
};

export default FinancialServices;